module.exports = __webpack_public_path__ + "img/69.787a0fcc.jpg";